import gql from 'graphql-tag';

export const GetAllClients = gql`
  query GetAllClients {
    getAllClients {
      id
      name
      url
      logo
    }
  }
`;

export const GetAllClientsForVendor = gql`
  query GetAllClientsForVendor($vendorId: ID!) {
    getAllClientsForVendor(vendor_id: $vendorId) {
      id
      name
      url
      logo
    }
  }
`;

export const GetAllHiringCompanies = gql`
  query GetAllHiringCompanies {
    getAllHiringCompanies {
      id
      name
      workspace {
        id
        name
        url
        logo
      }
    }
  }
`;
